module.exports = __webpack_public_path__ + "static/media/sorry.a61f8641.png";